import script from "./WSConnector.vue?vue&type=script&lang=js"
export * from "./WSConnector.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__